import React from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { NavLink } from 'reactstrap';

class LinkContainer extends React.Component {
  render() {
    const props = {
      className: "pointer "
    };

    if(this.props.className)
      props.className += this.props.className;

    return (
      <this.props.tag onClick={() => this.props.changeLocation(this.props.to)} {...props} >
        { this.props.children }
      </this.props.tag>
    );
  }
}

LinkContainer.defaultProps = {
  tag: NavLink
};

export const Link = connect(
  null,
  dispatch => ({
    changeLocation: to => dispatch(push(to))
  })
)(LinkContainer);



// WEBPACK FOOTER //
// ./src/components/link/Link.js